import { render, staticRenderFns } from "./OtherStoreList.vue?vue&type=template&id=7d88b2e2"
import script from "./OtherStoreList.vue?vue&type=script&lang=js"
export * from "./OtherStoreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports